<template>
  <div v-bind="$attrs" class="grid">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "GridRow",
});
</script>
